import { HighOrderError } from './HighOrderError';

export class ModuleMissingError extends HighOrderError {
    public readonly name = 'ModuleMissingError';
}
